import * as React from "react";
import {
  Dialog,
  DialogContent,
  DialogTitle,
  Typography,
  Box,
  IconButton,
  Stack,
  Card,
  CardContent,
} from "@mui/material";
import { QRCodeSVG } from "qrcode.react";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import { enqueueSnackbar } from "notistack";

export const ImageUploadQRDialog = ({
  open,
  setOpen,
  url,
  showTypedLink = true,
}) => {
  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(url);
      enqueueSnackbar("Link copied to clipboard", {
        variant: "success",
        autoHideDuration: 2000,
      });
    } catch (e) {
      console.log(e);
      enqueueSnackbar("Failed to copy link", {
        variant: "error",
        autoHideDuration: 2000,
      });
    }
  };
  return (
    <Dialog
      open={open}
      onClose={() => setOpen(false)}
      fullWidth
      slotProps={{
        paper: {
          component: "form",
          sx: { backgroundImage: "none" },
        },
      }}
    >
      <DialogTitle>
        <Typography variant={"h4"}>Mobile Upload</Typography>
      </DialogTitle>
      <DialogContent>
        <Stack direction="column" spacing={2} alignItems="center">
          <Typography gutterBottom textAlign="center">
            Scan this QR code with your phone to submit a handwritten answer
          </Typography>
          <Box my={1}>
            <QRCodeSVG value={url || ""} size={200} />
          </Box>

          {showTypedLink && (
            <>
              <Typography gutterBottom textAlign="center">
                Or
              </Typography>

              <Typography gutterBottom textAlign="center">
                Use the link below to paste a typed answer
              </Typography>
              <Card variant={"background"} sx={{ maxWidth: "90%", p: 1.2 }}>
                <CardContent>
                  <Stack direction={"row"} spacing={1} alignItems={"center"}>
                    <Typography
                      sx={{
                        maxWidth: "100%", // constrain to parent width
                        overflow: "hidden", // hide overflow
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                      }}
                    >
                      {url}
                    </Typography>
                    <IconButton
                      aria-label="Copy link"
                      onClick={handleCopy}
                      edge="end"
                      size="small"
                      sx={{ border: "none" }}
                    >
                      <ContentCopyIcon />
                    </IconButton>
                  </Stack>
                </CardContent>
              </Card>
            </>
          )}
        </Stack>
      </DialogContent>
    </Dialog>
  );
};
